import { render } from "./RedZonesSaveModal.vue?vue&type=template&id=5a57186a"
import script from "./RedZonesSaveModal.vue?vue&type=script&lang=js"
export * from "./RedZonesSaveModal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__